import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer } from '../Common';
import { connect } from 'react-redux';
import { buyerLogin } from '../../Action/login';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { GoogleLoginItem } from './GoogleLoginItem';
import { FacebookLoginItem } from './FacebookLoginItem';
class ValidMail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            buyerEmail: '',
            buyerPassword: '',
            user_type: 1,
            errors: [],
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors })
        }
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSocialLogin = (user) => {
        console.log('asd')
        console.log(user)
    }

    handleSocialLoginFailure = (err) => {
        console.log('asd')
        console.error(err)
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        // if (this.validator.allValid()) {
        let data = {
            email: this.state.buyerEmail,
            password: this.state.buyerPassword,
        }
        console.log(data);
        this.props.buyerLogin(data, this.props.history);
        // } else {
        //     this.validator.showMessages();
        // }
    }

    render() {
        return (
            <div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                        <div className="mt-5" style={{textAlign: "center", height: "560px"}}>
                            <div>
                                <span>仮登録ありがとうございます！</span>
                            </div>
                            <div>
                                <span>下記メールアドレスに、認証用URLをお送りしました。</span>
                            </div>
                            <div>
                                <span>メールに記載されている認証用URLをクリックして本登録を行ってください。</span>
                            </div>
                            <div>
                                <span>メールアドレス：{JSON.parse(window.localStorage.getItem('email'))}</span>
                            </div>   
                            <br/>                                             
                        </div>
                    </div>
                </div>
                <div className=" mt-5">
                    <Footer />
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
//     errors: state.errors,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(withRouter(BuyerLogin));

export { ValidMail };